module.exports = __webpack_public_path__ + "img/research4.66aa3575.jpg";